"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mimeData = exports.FileKind = void 0;
var FileKind;
(function (FileKind) {
    FileKind["Image"] = "image";
    FileKind["Video"] = "video";
    FileKind["Audio"] = "audio";
    FileKind["Archive"] = "archive";
    FileKind["Document"] = "document";
    FileKind["Spreadsheet"] = "spreadsheet";
    FileKind["Presentation"] = "presentation";
    FileKind["Font"] = "font";
    FileKind["Text"] = "text";
    FileKind["Application"] = "application";
    FileKind["Unknown"] = "unknown";
})(FileKind = exports.FileKind || (exports.FileKind = {}));
exports.mimeData = {
    'audio/aac': { extensions: ['.aac'], label: 'AAC audio', kind: FileKind.Audio },
    'application/x-abiword': {
        extensions: ['.abw'],
        label: 'AbiWord document',
        kind: FileKind.Document,
    },
    'application/x-freearc': {
        extensions: ['.arc'],
        label: 'Archive document (multiple files embedded)',
        kind: FileKind.Archive,
    },
    'video/x-msvideo': { extensions: ['.avi'], label: 'AVI: Audio Video Interleave', kind: FileKind.Video },
    'application/vnd.amazon.ebook': {
        extensions: ['.azw'],
        label: 'Amazon Kindle eBook format	application/vnd.amazon.ebook',
        kind: FileKind.Document,
    },
    'application/octet-stream': {
        extensions: ['.bin', '.exe', '.dll', '.so', '.dmg'],
        label: 'Any kind of binary data',
        kind: FileKind.Application,
    },
    'image/bmp': { extensions: ['.bmp'], label: 'Bitmap Graphics', kind: FileKind.Image },
    'application/x-bzip': { extensions: ['.bz'], label: 'BZip archive', kind: FileKind.Archive },
    'application/x-bzip2': { extensions: ['.bz2'], label: 'BZip2 archive', kind: FileKind.Archive },
    'application/x-cdf': { extensions: ['.cda'], label: 'CD audio', kind: FileKind.Audio },
    'application/x-csh': { extensions: ['.csh'], label: 'C-Shell script', kind: FileKind.Text },
    'text/css': { extensions: ['.css'], label: 'Cascading Style Sheets (CSS)', kind: FileKind.Text },
    'text/csv': {
        extensions: ['.csv'],
        label: 'Comma/column-separated values',
        kind: FileKind.Spreadsheet,
    },
    'text/tsv': {
        extensions: ['.tsv'],
        label: 'Tab-separated values',
        kind: FileKind.Spreadsheet,
    },
    'application/msword': { extensions: ['.doc'], label: 'Microsoft Word', kind: FileKind.Document },
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
        extensions: ['.docx'],
        label: 'Microsoft Word (OpenXML)',
        kind: FileKind.Document,
    },
    'application/vnd.ms-fontobject': {
        extensions: ['.eot'],
        label: 'MS Embedded OpenType fonts',
        kind: FileKind.Font,
    },
    'application/epub+zip': {
        extensions: ['.epub'],
        label: 'Electronic publication (EPUB)',
        kind: FileKind.Document,
    },
    'application/gzip': { extensions: ['.gz', '.gzip'], label: 'GZip Compressed Archive', kind: FileKind.Archive },
    'image/gif': { extensions: ['.gif'], label: 'Graphics Interchange Format (GIF)', kind: FileKind.Image },
    'application/html': {
        extensions: ['.htm', '.html'],
        label: '.html	HyperText Markup Language (HTML)',
        kind: FileKind.Text,
    },
    'image/vnd.microsoft.icon': {
        extensions: ['.ico'],
        label: 'Icon format	image/vnd.microsoft.icon',
        kind: FileKind.Image,
    },
    'text/calendar': { extensions: ['.ics'], label: 'iCalendar format', kind: FileKind.Text },
    'application/java-archive': {
        extensions: ['.jar'],
        label: 'Java Archive (JAR)	application/java-archive',
        kind: FileKind.Application,
    },
    'image/jpeg': { extensions: ['.jpeg', '.jpg'], label: 'JPEG image', kind: FileKind.Image },
    'text/javascript': {
        extensions: ['.js', '.mjs', '.jsx', '.ts', '.tsx'],
        label: 'JavaScript',
        kind: FileKind.Text,
    },
    'application/json': { extensions: ['.json'], label: 'JSON', kind: FileKind.Text },
    'application/ld+json': { extensions: ['.jsonld'], label: 'JSON-LD format	application/ld+json', kind: FileKind.Text },
    'audio/midi': {
        extensions: ['.mid', '.midi'],
        label: '.midi	Musical Instrument Digital Interface (MIDI)',
        kind: FileKind.Audio,
    },
    'audio/x-midi': {
        extensions: ['.mid', '.midi'],
        label: '.midi	Musical Instrument Digital Interface (MIDI)',
        kind: FileKind.Audio,
    },
    'audio/mpeg': { extensions: ['.mp3'], label: 'MP3 audio', kind: FileKind.Audio },
    'video/mp4': { extensions: ['.mp4'], label: 'MP4 video', kind: FileKind.Video },
    'video/mpeg': { extensions: ['.mpeg'], label: 'MPEG Video', kind: FileKind.Video },
    'application/vnd.apple.installer+xml': {
        extensions: ['.mpkg'],
        label: 'Apple Installer Package',
        kind: FileKind.Application,
    },
    'application/vnd.oasis.opendocument.presentation': {
        extensions: ['.odp'],
        label: 'OpenDocument presentation document',
        kind: FileKind.Presentation,
    },
    'application/vnd.oasis.opendocument.spreadsheet': {
        extensions: ['.ods'],
        label: 'OpenDocument spreadsheet document',
        kind: FileKind.Spreadsheet,
    },
    'application/vnd.oasis.opendocument.text': {
        extensions: ['.odt'],
        label: 'OpenDocument text document',
        kind: FileKind.Document,
    },
    'audio/ogg': { extensions: ['.oga', '.ogg'], label: 'OGG audio', kind: FileKind.Audio },
    'video/ogg': { extensions: ['.ogv'], label: 'OGG video', kind: FileKind.Video },
    'application/ogg': { extensions: ['.ogx'], label: 'OGG', kind: FileKind.Video },
    'audio/opus': { extensions: ['.opus'], label: 'Opus audio', kind: FileKind.Audio },
    'font/otf': { extensions: ['.otf'], label: 'OpenType font', kind: FileKind.Font },
    'image/png': { extensions: ['.png'], label: 'Portable Network Graphics', kind: FileKind.Image },
    'application/pdf': { extensions: ['.pdf'], label: 'Adobe Portable Document Format (PDF)', kind: FileKind.Document },
    'application/x-httpd-php': {
        extensions: ['.php'],
        label: 'Hypertext Preprocessor (Personal Home Page)',
        kind: FileKind.Text,
    },
    'application/vnd.ms-powerpoint': { extensions: ['.ppt'], label: 'Microsoft PowerPoint', kind: FileKind.Presentation },
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
        extensions: ['.pptx'],
        label: 'Microsoft PowerPoint (OpenXML)',
        kind: FileKind.Presentation,
    },
    'application/vnd.rar': { extensions: ['.rar'], label: 'RAR archive', kind: FileKind.Archive },
    'application/rtf': { extensions: ['.rtf'], label: 'Rich Text Format (RTF)', kind: FileKind.Document },
    'application/x-sh': { extensions: ['.sh'], label: 'Bourne shell script', kind: FileKind.Text },
    'image/svg+xml': { extensions: ['.svg'], label: 'Scalable Vector Graphics (SVG)', kind: FileKind.Image },
    'image/svg': { extensions: ['.svg'], label: 'Scalable Vector Graphics (SVG)', kind: FileKind.Image },
    'application/x-shockwave-flash': {
        extensions: ['.swf'],
        label: 'Adobe Flash document',
        kind: FileKind.Application,
    },
    'application/x-tar': { extensions: ['.tar'], label: 'Tape Archive (TAR)	application/x-tar', kind: FileKind.Archive },
    'image/tiff': {
        extensions: ['.tif'],
        label: '.tiff File Format (TIFF)',
        kind: FileKind.Image,
    },
    'video/mp2t': { extensions: ['.ts'], label: 'MPEG transport stream', kind: FileKind.Video },
    'font/ttf': { extensions: ['.ttf'], label: 'TrueType Font	font/ttf', kind: FileKind.Font },
    'text/plain': { extensions: ['.txt'], label: 'Plain Text', kind: FileKind.Text },
    'application/vnd.visio': { extensions: ['.vsd'], label: 'Microsoft Visio', kind: FileKind.Image },
    'audio/wav': { extensions: ['.wav'], label: 'Waveform Audio Format', kind: FileKind.Audio },
    'audio/webm': { extensions: ['.weba'], label: 'WEBM audio', kind: FileKind.Audio },
    'video/webm': { extensions: ['.webm'], label: 'WEBM video', kind: FileKind.Video },
    'image/webp': { extensions: ['.webp'], label: 'WEBP image', kind: FileKind.Image },
    'image/heic': {
        extensions: ['.heic', '.heif'],
        label: 'HEIC (High-Efficiency Image Container) image',
        kind: FileKind.Image,
    },
    'font/woff': { extensions: ['.woff'], label: 'Web Open Font Format (WOFF)', kind: FileKind.Font },
    'font/woff2': { extensions: ['.woff2'], label: 'Web Open Font Format (WOFF)', kind: FileKind.Font },
    'application/xhtml+xml': { extensions: ['.xhtml'], label: 'XHTML', kind: FileKind.Text },
    'application/vnd.ms-excel': { extensions: ['.xls'], label: 'Microsoft Excel', kind: FileKind.Spreadsheet },
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
        extensions: ['.xlsx'],
        label: 'Microsoft Excel (OpenXML)',
        kind: FileKind.Spreadsheet,
    },
    'application/xml': {
        extensions: ['.xml'],
        label: 'XML',
        kind: FileKind.Text,
    },
    'text/xml': {
        extensions: ['.xml'],
        label: 'XML',
        kind: FileKind.Text,
    },
    'application/zip': { extensions: ['.zip'], label: 'ZIP archive', kind: FileKind.Archive },
    'video/3gpp': {
        extensions: ['.3gp'],
        label: '3GPP audio/video container',
        kind: FileKind.Video,
    },
    'audio/3gpp': {
        extensions: ['.3gp'],
        label: '3GPP audio/video container',
        kind: FileKind.Audio,
    },
    'video/3gpp2': {
        extensions: ['.3g2'],
        label: '3GPP2 audio/video container',
        kind: FileKind.Video,
    },
    'audio/3gpp2': {
        extensions: ['.3g2'],
        label: '3GPP2 audio/video container',
        kind: FileKind.Audio,
    },
    'application/x-7z-compressed': {
        extensions: ['.7z'],
        label: '7-zip archive	application/x-7z-compressed',
        kind: FileKind.Archive,
    },
};
